/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import downloadIcon from "dc-icons/viewer2021/SDC_Download_18_N.svg";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import { downloadAssetFromDocApi } from "utils/DownloadUtility";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import * as stores from "stores";

export const onDownloadFileClick = (stores, extraParams) => {
  downloadAssetFromDocApi(stores, extraParams).catch(() => {});
};

export const getDownloadFileAction = props => {
  let shouldShowDownloadButton = true;
  if (!props.enableDownloadFeature) {
    shouldShowDownloadButton = false;
  }
  const downloadLabel = getShouldUseModernViewer(stores) ? "tooltip.modernViewer.download" : "tooltip.download";
  const ariaLabel = getShouldUseModernViewer(stores) ? "arialabel.modernViewer.download" : "tooltip.download";

  return shouldShowDownloadButton === true
    ? {
        id: "documentDownload",
        label: props.intl.formatMessage({ id: downloadLabel }),
        ariaLabel: props.intl.formatMessage({ id: ariaLabel }),
        onClick: () => {
          props.onDownloadFileClick({
            triggeredFrom: "topbar"
          });
        },
        Icon: <CustomIcon url={downloadIcon} />
      }
    : null;
};
